import React from 'react';
import autoBind from 'react-autobind';
import Divider from 'material-ui/Divider';
import IconButton from 'material-ui/IconButton';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import { List, ListItem } from 'material-ui/List';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import MarkerCategoryModal from '../MarkerCategoryModal';
import { Panel } from '../../components/Panel';
import style from './style.js';
import { MarkerTypeCategoryRecord } from '../../feathers/records';

export class MarkerCategoryPanel extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      currentlyEditing: null
    };
  }

  handleOpenModal(markerCategory) {
    this.setState({ currentlyEditing: markerCategory });
  }

  handleCloseModal() {
    this.setState({ currentlyEditing: null });
  }

  render() {
    const { markerTypeCategories, markerTypes, disabled } = this.props;
    return (
      <div>
        <Panel>
          {this.state.currentlyEditing && (
            <MarkerCategoryModal
              markerCategory={this.state.currentlyEditing}
              onRequestClose={this.handleCloseModal}
            />
          )}
          <div className="row middle-xs">
            <div className="col-xs-7">
              <p className="text-muted">{`${
                markerTypeCategories.size
              } marker type categories`}</p>
            </div>
            <div className="col-xs-5">
              <FlatButton
                primary
                fullWidth
                label="New Category"
                onClick={() =>
                  this.handleOpenModal(new MarkerTypeCategoryRecord())
                }
                disabled={disabled}
              />
            </div>
          </div>
          {markerTypeCategories.size > 0 && (
            <div>
              <List style={style.markerList}>
                {markerTypeCategories.toList().map((category, index) => {
                  const totalMarkerTypes = markerTypes
                    .toList()
                    .filter(
                      markerType => markerType.category_id === category._id
                    ).size;
                  return (
                    <div key={category._id}>
                      <ListItem
                        primaryText={category.name}
                        secondaryText={`${totalMarkerTypes} marker types in this category`}
                        onClick={() => this.handleOpenModal(category)}
                        disabled={disabled}
                        tooltip="Edit Marker Category"
                        tooltipPosition="bottom-left"
                        rightIconButton={
                          <IconButton
                            style={{ pointerEvents: 'none' }}
                            className="list_item"
                          >
                            <EditIcon color="#999999" />
                          </IconButton>
                        }
                      />
                      <Divider />
                    </div>
                  );
                })}
              </List>
              <div className="row end-xs middle-xs">
                <div className="col-xs-6">
                  <RaisedButton
                    primary
                    fullWidth
                    label="New Category"
                    onClick={() =>
                      this.handleOpenModal(new MarkerTypeCategoryRecord())
                    }
                    disabled={disabled}
                  />
                </div>
              </div>
            </div>
          )}
        </Panel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MarkerCategoryPanel/index.jsx